import { OPERO_BRAND, OPERO_LOGOS } from "../../brand";
import { cn } from "../../lib/utils";

interface BrandLockupProps {
  className?: string;
  size?: "sm" | "md";
}

/**
 * Logo mark + wordmark — used in modal headers and the workspace setup page
 * where `OperoLogo variant="full"` (a single PNG with embedded text) renders
 * poorly on light backgrounds.
 */
export function BrandLockup({ className, size = "md" }: BrandLockupProps) {
  const dim = size === "sm" ? "h-6 w-6" : "h-7 w-7";
  const text = size === "sm" ? "text-sm" : "text-base";
  return (
    <div className={cn("flex items-center gap-2", className)}>
      <img src={OPERO_LOGOS.logo} alt="" className={dim} />
      <span className={cn("font-bold text-slate-900 dark:text-white", text)}>
        {OPERO_BRAND.name}
      </span>
    </div>
  );
}
